import { observer } from 'mobx-react-lite';
import * as React from 'react';

import TreeFolder from '@/components/shared/TreeFolder';
import { TreeNodeFolder } from '@/entities/Tree';
import { TreeStore } from '@/stores/local/shared/TreeStore';

import Actions from './Actions';

import s from './Folder.module.scss';

type Props = {
  store: TreeStore;
  model: TreeNodeFolder;
};

const Folder: React.FC<Props> = ({ store, model }) => {
  return (
    <TreeFolder
      className={s.root}
      store={store}
      model={model}
      onClick={store.toggle}
      actions={<Actions store={store} />}
    />
  );
};

export default observer(Folder);
